var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveBox = function SvgRemoveBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    style: {
      boxShadow: "0 2px 40px 0 rgba(0,0,0,.201)",
      borderRadius: 5
    },
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 0H5a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.59 7 11 9.59 8.41 7 7 8.41 9.59 11 7 13.59 8.41 15 11 12.41 13.59 15 15 13.59 12.41 11 15 8.41z"
  })));
};
export default SvgRemoveBox;